import { Box, useTheme } from "@mui/material";
import { InternalLink } from "@/common/CommonComponents";

export default function LogoButton({ sx }) {
    const theme = useTheme();

    return (
        <InternalLink href="dashboard">
            <Box
                component="img"
                src={`/MakeOS-Logo-${theme.palette.mode}-theme.svg`}
                alt="MakeOS home"
                sx={{ width: "48px", cursor: "pointer", ...sx }}
            />
        </InternalLink>
    );
}
